export default __webpack_public_path__ + "static/media/m7.cf70c363.jpg";